import { BookFormat, BookGenre, BookCondition, BookPurchaseCondition, YesNoState } from './constants';
import typeHints from './typeHints';

const attributes = {

  book_author_name: {
    friendly: 'Author',
    validations: {
      maxLength: 255,
    },
  },

  book_sub_title: {
    friendly: 'Sub Title',
    validations: {
      maxLength: 255,
    },
  },

  book_ISBN: {
    friendly: 'ISBN',
    validations: {
      maxLength: 255,
    },
  },

  book_publication_date: {
    friendly: 'Publication Date',
    validations: {
      type: 'date',
    },
    typeHint: typeHints.Date,
  },

  book_publisher: {
    friendly: 'Publisher',
    validations: {
      maxLength: 255,
    },
  },

  book_format: {
    friendly: 'Format',
    validations: {
      type: 'enum',
      enumType: BookFormat,
    },
  },

  book_country: {
    friendly: 'Country',
    validations: {
      maxLength: 255,
    },
  },

  book_language: {
    friendly: 'Language',
    validations: {
      maxLength: 255,
    },
  },

  book_genre: {
    friendly: 'Genre',
    validations: {
      type: 'enum',
      enumType: BookGenre,
    },
  },

  book_subject: {
    friendly: 'Subject',
    validations: {
      maxLength: 255,
    },
  },

  book_plot: {
    friendly: 'Plot',
    validations: {
      maxLength: 32000,
    },
    typeHint: typeHints.TextArea,
  },

  book_cover_price: {
    friendly: 'Cover Price',
    validations: {
      maxLength: 150,
    },
    typeHint: typeHints.Monetary,
  },

  book_no_of_pages: {
    friendly: 'No. of Pages',
    validations: {
      maxLength: 45,
    },
  },

  book_dimensions: {
    friendly: 'Dimensions',
    validations: {
      maxLength: 255,
    },
  },

  book_signature: {
    friendly: 'Signature',
    validations: {
      maxLength: 255,
    },
  },

  book_rating: {
    friendly: 'Rating',
    validations: {
      maxLength: 255,
    },
  },

  book_condition: {
    friendly: 'Condition',
    validations: {
      type: 'enum',
      enumType: BookCondition,
    },
  },

  book_series: {
    friendly: 'Series',
    validations: {
      maxLength: 255,
    },
  },

  book_issue_no: {
    friendly: 'Issue No.',
    validations: {
      maxLength: 255,
    },
  },

  book_box_set: {
    friendly: 'Box Set',
    validations: {
      maxLength: 255,
    },
  },

  book_volume: {
    friendly: 'Volume',
    validations: {
      maxLength: 255,
    },
  },

  book_edition: {
    friendly: 'Edition',
    validations: {
      maxLength: 255,
    },
  },

  book_printer: {
    friendly: 'Printer',
    validations: {
      maxLength: 255,
    },
  },

  book_no_printed: {
    friendly: 'No. Printed',
    validations: {
      maxLength: 255,
    },
  },

  book_paper_type: {
    friendly: 'Paper Type',
    validations: {
      maxLength: 255,
    },
  },

  book_loc_classification: {
    friendly: 'LoC Classification',
    validations: {
      maxLength: 255,
    },
  },

  book_loc_control_no: {
    friendly: 'LoC Control No.',
    validations: {
      maxLength: 255,
    },
  },

  book_dewey: {
    friendly: 'Dewey',
    validations: {
      maxLength: 255,
    },
  },

  book_purchase_condition: {
    friendly: 'Purchase Condition',
    validations: {
      type: 'enum',
      enumType: BookPurchaseCondition,
    },
  },

  book_location_bookshelf: {
    friendly: 'Bookshelf?',
    validations: {
      type: 'enum',
      enumType: YesNoState,
    },
  },

  book_location_row: {
    friendly: 'Row #',
    validations: {
      maxLength: 255,
    },
  },

  book_location_book: {
    friendly: 'Book #',
    validations: {
      maxLength: 150,
    },
  },

};

export default attributes;

export const BookDefaultSplitAttribute = 'book_author_name';

export const BookItemSearchAttributes = [];

export const BookOverviewAttributes = ['title', 'book_author_name', 'book_ISBN', 'book_publication_date', 'book_publisher', 'book_genre',
  'book_condition', 'rarity', 'market_value', 'quantity', 'inventory_no', 'tags'];

export const BookSpecificationAttributes = ['book_edition', 'book_format', 'book_country', 'book_language', 'book_cover_price',
  'book_no_of_pages', 'book_dimensions', 'book_signature', 'book_loc_classification', 'book_loc_control_no', 'book_dewey'];

export const BookPurchaseAttributes = ['purchase_date', 'purchase_price', 'book_purchase_condition', 'purchase_contact', 'purchase_notes'];

export const BookDetailAttributes = ['book_subject', 'book_rating', 'book_series', 'book_issue_no', 'book_box_set', 'book_volume',
  'book_printer', 'book_no_printed', 'book_paper_type', 'book_plot'];

export const BookRequiredAttributes = [];

export const BookDisplayAttributes = ['book_author_name', 'book_publisher', 'book_publication_date', 'book_genre', 'book_edition', 'tags'];

export const BookSliderGalleryAttributes = {
  titleKey: 'title',
  subtitleKey: 'book_author_name',
};



// WEBPACK FOOTER //
// ./src/config/bookDataAttributes.js